import React from 'react'
import * as api from '../../../api';
import { toast } from 'react-toastify';
import { Grid, Button, Input, Modal, Dropdown,Message } from 'semantic-ui-react';
import UserTabs from '../manage-users/users/user-tabs'

class AddUserModal extends React.Component {
    constructor(props) {
        super(props)

        this.handleNewUser = this.handleNewUser.bind(this);


        this.state = {
            rolesList: [],
            open: false,
            firstName: "",
            surname: "",
            userId: "",
            roleId: "8C9BB5E1-8D20-4F5B-8376-A69980D58A1A",
            id: "",
            userCreateComplete: false,
            sites: [],
            selectedSites: [],
            showModal: false, // To control the site selection modal
            selectedroleId : ''
        }
        this.fetchData();
    }
    fetchData() {
        api.getRolesList(this.props.customerId)
            .then(data => {
                this.setState({ rolesList: data });
            }).catch(function (error) {
                // Acquire token interactive failure
                console.log(error);
            });

    }
    onNewUserDetails = (event, data) => {
        this.setState({ [data.name]: data.value })
    }

    handleNewUser = (event) => {
        if (this.state.firstName === '' || this.state.surname === '' || this.state.userId === '') {
            return
        }
        const formData = new FormData();





        formData.append("Username", this.state.userId);
        formData.append("IsFundLevel", false);
        formData.append("IsReadOnly  ", false);
        formData.append("firstName", this.state.firstName);
        formData.append("surname", this.state.surname);
        formData.append("ClientId", this.props.customerId)
        formData.append("UserDirectory", "INSITE")
        formData.append("userId", this.state.userId);
        formData.append("UserPrincipalName", this.state.userId);
        formData.append("DashboardUser", false);
        formData.append("RoleId", this.state.roleId);

       // try {
            api.postNewUserDetails(formData)
                .then( verifyRes  => {
                  

                    if (verifyRes.status === "Success") {
                       
                        this.notify("Successfully saved !");

                        this.setState({
                            id: verifyRes.id,
                            userCreateComplete: true
                            
                        });

                    }else
                    {

                        this.notify(verifyRes.error[0].description,true);
                       
                    }


                    this.setState({
                        selectedroleId : this.state.roleId,
                        firstName: '',
                        surname: '',
                        userId: '',
                        roleId: ""
                    })

                })
                .catch((error) => {
                  
                  
                    this.notify("Unhandled Error - contact IT Helpdesk",true);

                    this.setState({
                        firstName: '',
                        surname: '',
                        userId: '',
                        roleId: ""
                    })
                });
      

     
    }

    notify = (message,error = false) => {
        if(error)
        {
            toast.error(message, {
                position: toast.POSITION.TOP_CENTER,
                delay: 2000
            });
        }else
        {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER,
            delay: 2000
        });
    }
    }


    render() {
        
        const roles = this.state.rolesList.filter((item) => {
            return (item.roleName === "Client User All" || item.roleName === "Client User")

        })

        const options = []
        for (let i = 0; i < roles.length; i++) {
            if (roles[i].roleName === "Client User All") { options.push({ key: roles[i].roleId, text: "Access to whole client Portfolio", value: roles[i].roleId , selected: true }); }
            if (roles[i].roleName === "Client User") { options.push({ key: roles[i].roleId, text: "Access to only my sites", value: roles[i].roleId }); }
        }

        return <>
            <Modal size="medium"
                trigger={<Button id='add-user' compact floated='right' size="big" >Add User</Button>}
                onOpen={() => this.setState({ open: true })}
                onClose={() => this.setState({ open: false })}
                open={this.state.open}
            >
                <Modal.Header>New User Details</Modal.Header>
                <Modal.Content >
                    <Grid padded stackable columns='equal'>
                        <Grid.Row>
                            <Grid.Column>
                                <Input icon='user'
                                    fluid
                                    placeholder='Please enter first name'
                                    name="firstName"
                                    disabled={this.state.userCreateComplete}
                                    onChange={this.onNewUserDetails}

                                />
                            </Grid.Column>

                            <Grid.Column>
                                <Input icon='user'
                                    placeholder='Please enter last name'
                                    fluid
                                    name="surname"
                                    disabled={this.state.userCreateComplete}
                                    onChange={this.onNewUserDetails}

                                />
                            </Grid.Column>

                            <Grid.Column>
                                <Input icon='at'
                                    fluid
                                    placeholder='Please enter e-mail address'
                                    name="userId"
                                    disabled={this.state.userCreateComplete}
                                    onChange={this.onNewUserDetails}

                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Dropdown
                                    fluid
                                    selection
                                    placeholder='Please select a role'
                                    options={options}
                                    defaultValue="8C9BB5E1-8D20-4F5B-8376-A69980D58A1A"
                                    name="roleId"
                                    onChange={this.onNewUserDetails}
                                />
                            </Grid.Column>
                            <Grid.Column></Grid.Column>
                            <Grid.Column></Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Grid padded >
                        <Grid.Row>
                            <Grid.Column>
                            {this.state.userCreateComplete && this.props.customerId === "15592" && this.state.selectedroleId !== "8C9BB5E1-8D20-4F5B-8376-A69980D58A1A" && (
                                    <Message info>
                                        <Message.Header>Site Access Information</Message.Header>
                                        <p>This user has the below sites active on ICMAS site contacts via the PAM UK master list. If selecting &apos;Access to only my sites&apos;, the user will have these sites added when they log in. Any issues with this, 
                                            please review the ICMAS contacts and PAM. Any additional sites added below will be uneffected by PAM changes. *Note sites are not removed from this list via PAM sync</p>
                                    </Message>
                                )}
                                {this.state.userCreateComplete &&
                                <UserTabs customerId={this.props.customerId} id={this.state.id} toggledTab={this.props.toggledTab} isFundLevel={false} isReadOnly={false}/>
                                 }
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        basic color='red'
                        compact
                        onClick={() => this.setState({ open: false })}
                    >Cancel</Button>
                   
                     {this.state.userCreateComplete ?
                  <Button
                        compact
                        onClick={() => 
                            
                            {
                                this.setState({ open: false })
                                this.notify("Successfully saved !");
                                this.props.notifyParent();

                            }
                    }
                    >Complete Setup</Button>
                    :
                    <Button
                    compact
                    id='confirm-user'
                    
                    onClick={this.handleNewUser}
                >Add User</Button>
                }
                </Modal.Actions>
            </Modal>
        </>
    }
}
export default AddUserModal;